<template>
  <section class="info-card">
    <h2 class="info-card__title">{{ title }}</h2>
    <div v-for="row in rows" :key="row.label" class="info-card__row">
      <span class="info-card__label">{{ row.label }}</span>
      <span class="info-card__value">{{ row.value }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: String,
    rows: Array,
  },
}
</script>

<style lang="sass" scoped>
.info-card
  padding: 20px
  border: 1px solid #e5e5e5
  border-radius: 14px

.info-card__title
  margin-bottom: 14px
  color: #232323
  font-size: 18px
  font-weight: 600

.info-card__row
  display: flex
  align-items: flex-start
  justify-content: space-between
  gap: 18px
  padding: 12px 0
  border-bottom: 1px solid #ededed
  font-size: 15px
  line-height: 1.35

  &:last-child
    padding-bottom: 0
    border-bottom: 0

.info-card__label
  flex-shrink: 0
  color: #858585

.info-card__value
  color: #353535
  text-align: right
  overflow-wrap: anywhere
</style>
